import React from 'react'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import Switcher, { Checked } from 'commons/js/ui/Switcher'

import { FILTER_ALL, FILTER_AIRPORTS } from '../SearchForm'

export {
    Checked,
    FILTER_ALL,
    FILTER_AIRPORTS,
}

const AirportSwitcher = ({ onChange, selected }) => <Switcher
  primaryOption={{value: FILTER_ALL, label: <FormattedMessage defaultMessage='Todos los parkings' />}}
  secondaryOption={{value: FILTER_AIRPORTS, label: <FormattedMessage defaultMessage='Aeropuertos' />}}
  selected={selected}
  onChange={onChange} />

AirportSwitcher.propTypes = {
    onChange: PropTypes.func,
    selected: PropTypes.string,
}

AirportSwitcher.defaultProps = {
    selected: FILTER_ALL,
    onChange: () => {},
}

export default AirportSwitcher
